export default function CareersHero() {
  return (
    <section className="bg-[#2B2B2B] pt-52 pb-24">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
          Careers
        </h1>
        <p className="text-xl md:text-2xl text-[#C5A55A] font-light">
          Build your future with Deer Point Contracting
        </p>
      </div>
    </section>
  );
}
